import React from 'react';

import { DialogType } from '../../../@types';
import { AdditionalQueryParams } from '../../../hooks/usePagination';
import useFilterForm from '../../../hooks/useFilterForm';
import { getCompleteName } from '../../../utils';
import FilterDialogLayout from '../../layouts/FilterDialogLayout';
import CustomerSelect from '../../molecules/CustomerSelect';

const defaultValues = {
  userId: undefined,
};

type FilterWelcomeBonusReportsData = {
  userId?: string;
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
  closeModal: () => void;
};

const FilterWelcomeBonusReports: React.FC<Props> = ({ changeQuery, closeModal }) => {
  const { control, handleSubmit, handleResetFilter } = useFilterForm<FilterWelcomeBonusReportsData>({
    defaultData: defaultValues,
    changeQuery,
  });

  return (
    <FilterDialogLayout onSave={handleSubmit} onClose={closeModal} onReset={handleResetFilter}>
      <CustomerSelect
        name='userId'
        label='Player'
        control={control}
        multipleSelect={false}
        getOptionLabel={(options, value) => {
          const option = options.find((option) => option?.userId === value);
          return option?.username
            ? `${getCompleteName(option.firstName, option.lastName, option.username)}`
            : 'No player selected';
        }}
      />
    </FilterDialogLayout>
  );
};

export default FilterWelcomeBonusReports;
